import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';

class RadioSelect extends Component {
  componentDidMount() {
    const { $ } = window;
    const { selectMetric } = this.props;
    $('select.radioSelect').on('change', function() {
      const metric = $(this)[0].value;
      selectMetric(metric);
    });
  }

  render() {
    return (
      <div className="radioSelect">
        <div className="input-field" style={{ height: 'inherit' }}>
          <select className="radioSelect">
            <option value="clicks">Clicks</option>
            <option value="impressions">Impressions</option>
            <option value="ctr">CTR</option>
            <option value="position">Position</option>
          </select>
          <label>Select metric for graph:</label>
        </div>
      </div>
    );
  }
}

function mapStateToProps({
  selectedMetric,
  selectedPage,
  startDate,
  endDate,
  selectedQuery
}) {
  return { selectedMetric, selectedPage, startDate, endDate, selectedQuery };
}

export default connect(mapStateToProps, actions)(RadioSelect);



// WEBPACK FOOTER //
// ./src/components/Dashboard/RadioSelect.js